<template>
  <div class='h100vh-100'>
    <!-- 非实时任务工具栏 -->
    <ToolBarForTaskList ref="toolBar" :taskStatus="taskStatus"></ToolBarForTaskList>

    <!-- 非实时任务列表 -->
    <TaskListForNoReal ref="gridForTaskList" :queryParams="queryParams" :tableType="tableType" @taskStatusChange="taskStatusChange"></TaskListForNoReal>

    <!-- 添加或修改非实时任务第一步弹出框 -->
    <CustomDialog ref='addOrModifyTaskPage1' :element='dialogForAddOrModifyTaskPage1.element' :styles='dialogForAddOrModifyTaskPage1.style'>
      <template v-slot:dialog-content>
        <AddOrModifyTaskDialog1 ref='AddOrModifyTaskDialog1' :addOrModifyTaskFlag="addOrModifyTaskFlag"></AddOrModifyTaskDialog1>
      </template>
    </CustomDialog>

    <!-- 添加或修改非实时任务第二步弹出框 -->
    <CustomDialog ref='addOrModifyTaskPage2' :element='dialogForAddOrModifyTaskPage2.element' :styles='dialogForAddOrModifyTaskPage2.style'>
      <template v-slot:dialog-content>
        <AddOrModifyTaskDialog2 ref='AddOrModifyTaskDialog2' :neIdsUnderTaskByTaskId="neIdsUnderTaskByTaskId" :addOrModifyTaskFlag="addOrModifyTaskFlag" :paramsOfFirstStep = 'paramsOfFirstStep'></AddOrModifyTaskDialog2>
      </template>
    </CustomDialog>

    <!-- 非实时任务详细信息弹出框 -->
    <CustomDialog ref='showDetailPage' :element='dialogForShowDetail.element' :styles='dialogForShowDetail.style'>
      <template v-slot:dialog-content>
        <ShowDetailDialog ref="showDetail" :paramsOfDetail="paramsOfDetail" :neTypeId="neTypeId"></ShowDetailDialog>
      </template>
    </CustomDialog>

    <CustomDialog ref="cmdConsolePage" :element="dialogForCmdConsolePage.element" :styles="dialogForCmdConsolePage.style">
      <template v-slot:dialog-content>
        <CmdConsole ref="CmdConsole"></CmdConsole>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import ToolBarForTaskList from './ToolBarForTaskList';
import TaskListForNoReal from './TaskListForNoReal';
import CustomDialog from '../../common/CustomDialog';
import AddOrModifyTaskDialog1 from './dialog/AddOrModifyTaskDialog1';
import AddOrModifyTaskDialog2 from './dialog/AddOrModifyTaskDialog2';
import ShowDetailDialog from './dialog/ShowDetailDialog';
import dateUtil from './dateUtil';
import CmdConsole from '../RealTimeTask/CmdConsole';
import pmSocket from '@/plugins/stompSock';
import commonUtil from '../RealTimeTask/commonUtil';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'NoRealTaskListPage',
  props: [
    'queryParams', // 存放网元树或测量对象树点击信息，树类型通过treeType字段来区分，1：测量对象树 2：网元树
    'tableType'
  ],
  components: {
    ToolBarForTaskList,
    CustomDialog,
    TaskListForNoReal,
    AddOrModifyTaskDialog1,
    AddOrModifyTaskDialog2,
    ShowDetailDialog,
    CmdConsole
  },
  data() {
    return {
      // 添加或修改非实时任务第一步弹出框配置信息
      dialogForAddOrModifyTaskPage1: {
        style: {
          width: '800px',
          height: '688px',
          visible: false,
          model: true
        },
        element: {
          title: `${this.$t('Pm.createTask')}：${this.$t('Pm.first')}`,
          target: this.$refs.gridForTaskList,
          refName: 'addTaskElement',
          buttonGroup: [
            { click: this.closeAddOrModifyTaskPage1, buttonModel: { content: this.$t('Pm.cancel') } },
            { click: this.nextForTask, buttonModel: { content: this.$t('Pm.nextStep') } }
          ],
          isClose: true
        }
      },

      // 添加或修改非实时任务第二步弹出框配置信息
      dialogForAddOrModifyTaskPage2: {
        style: {
          width: '800px',
          height: '688px',
          visible: false,
          model: true
        },
        element: {
          title: `${this.$t('Pm.createTask')}：${this.$t('Pm.second')}`,
          target: this.$refs.gridForTaskList,
          refName: 'addTaskElement',
          buttonGroup: [
            { click: this.closeAddOrModifyTaskPage2, buttonModel: { content: this.$t('Pm.cancel') } },
            { click: this.preForTask, buttonModel: { content: this.$t('Pm.preStep') } },
            { click: this.completeAddOrModifyTask, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
          ],
          isClose: true
        }
      },

      // 非实时任务详细信息弹出框配置信息
      dialogForShowDetail: {
        style: {
          width: '800px',
          height: '645px',
          visible: false,
          model: true
        },
        element: {
          title: this.$t('Pm.queryDetailInfo'),
          target: this.$refs.gridForTaskList,
          refName: 'showDetailElement',
          buttonGroup: [
            { click: this.closeShowDetailPage, buttonModel: { content: this.$t('Pm.confirm'), isPrimary: true} }
          ],
          isClose: true
        }
      },

      dialogForCmdConsolePage: {
        style: {
          width: '30%',
          height: '60%',
          visible: false,
          model: true
        },
        element: {
          title: this.$t('Pm.performTask'),
          target: this.$refs.gridForTaskList,
          refName: 'addTaskElement',
          buttonGroup: [
            {
              click: this.confirmCmdConsolePage,
              buttonModel: {
                content: this.$t('Pm.confirm'),
                isPrimary: true
              }
            }
          ],
          isClose: false
        }
      },

      taskStatus: 3,
      paramsOfFirstStep: {},
      addOrModifyTaskFlag: '1',
      addOrModifyParams: {},
      neWithMeasureObjs: [],
      paramsOfDetail: {},

      cmdExeFinshFlag: false, // 命令是否执行完毕
      timer1: undefined,
      timer2: undefined,
      payload: [
        { topic: '/user/#/PmTaskServer', clientId: '', callback: this.pmWebsocketLisenerOfNoReal }
      ],
      neTypeId: '',
      taskId: 0,
      neIdsUnderTaskByTaskId: [],
      hasSame: false,
      delNeIdsOfModify: [],
      neIdsForTask: []
    };
  },
  methods: {

    // 根据工具栏组件穿过来的值分发到相应的任务并执行
    methodList(operator) {
      switch (operator) {
        case 'add':
          this.addTaskPage();
          break;
        case 'hungUp':
          this.hungUpTask();
          break;
        case 'delete':
          this.deleteTask();
          break;
        case 'modify':
          this.modifyTaskPage();
          break;
        case 'active':
          this.activeTask();
          break;
        case 'consistency':
          this.checkConsistency();
          break;
        case 'sync':
          this.syncDownload();
          break;
        case 'detail':
          this.showDetailPage();
          break;
        default:
      }
    },

    // 新增任务
    addTaskPage() {
      this.$refs.AddOrModifyTaskDialog1.status = {
        begTimeEnabled: false,
        endTimeEnabled: false,
        neTypeEnabled: true,
        timeCycleEnabled: true,
        timeModeEnabled: true,
        readForTaskName: false,
        readForTaskDesc: false,
      };

      this.neIdsUnderTaskByTaskId = [];
      this.taskId = 0;
      this.$refs.AddOrModifyTaskDialog1.paramsOfDialog1 = {
        neType: '101',
        sysMeterTaskName: 'TASK_',
        sysMeterTaskDepict: '',
        meterTimePeriod: 2,
        effectiveTimeMode: '1',
        meterBegTime: new Date(),
        meterEndTime: new Date('2099-12-31 23:59:59'),
      };
      this.addOrModifyTaskFlag = '1';
      this.$refs.AddOrModifyTaskDialog1.bindValidateOfDialog1();
      this.$refs.addOrModifyTaskPage1.show();
    },

    // 挂起任务
    hungUpTask() {
      const data = this.$refs.gridForTaskList.rowData;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.sendCmdAndRecieveData('/lte/pm/measuretaskmanagement/doUnactiveTask.html', data, 1);
    },

    // 删除任务
    deleteTask() {
      const data = this.$refs.gridForTaskList.rowData;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.sendCmdAndRecieveData('/lte/pm/measuretaskmanagement/doDeleteTask.html', data, 1);
    },

    // 修改任务
    modifyTaskPage() {
      const data = this.$refs.gridForTaskList.rowData;

      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }

      this.$refs.AddOrModifyTaskDialog1.status = {
        begTimeEnabled: false,
        endTimeEnabled: false,
        neTypeEnabled: false,
        timeCycleEnabled: false,
        timeModeEnabled: false,
        readForTaskName: true,
      };

      this.taskId = data.sysMeterTaskId;

      this.$axios.get(`/lte/pm/measuretaskmanagement/getNeIdsUnderTaskByTaskId.html?taskId=${data.sysMeterTaskId}`).then((response) => {
        this.neIdsUnderTaskByTaskId = response.data.resultVal;
      })

      this.$axios.get(`/lte/pm/measuretaskmanagement/getNeInfoByTaskId.html?taskId=${data.sysMeterTaskId}`).then((response) => {
        const result = response.data.resultVal;
        if (result.length > 0) {
          this.neTypeId = result[0].neTypeId;
          this.$refs.AddOrModifyTaskDialog1.paramsOfDialog1 = {
            neType: result[0].neTypeId,
            sysMeterTaskName: data.sysMeterTaskName,
            sysMeterTaskDepict: data.sysMeterTaskDepict,
            meterTimePeriod: 2,
            effectiveTimeMode: data.effectiveTimeMode,
            meterBegTime: new Date(data.meterBegTime),
            meterEndTime: new Date(data.meterEndTime),
          };
          this.addOrModifyTaskFlag = '2';
          this.$refs.AddOrModifyTaskDialog1.bindValidateOfDialog1();
          this.$refs.addOrModifyTaskPage1.show();
        }
      });
    },

    // 激活任务
    activeTask() {
      const data = this.$refs.gridForTaskList.rowData;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.sendCmdAndRecieveData('/lte/pm/measuretaskmanagement/doActiveTask.html', data, 1);
    },

    // 一致性检查
    checkConsistency() {
      const data = this.$refs.gridForTaskList.rowData;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.sendCmdAndRecieveData('/lte/pm/measuretaskmanagement/doConsistentCheck.html', data, 1);
    },

    // 同步下载
    syncDownload() {
      const data = this.$refs.gridForTaskList.rowData;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.sendCmdAndRecieveData('/lte/pm/measuretaskmanagement/doSyncDownloadTask.html', data, 1);
    },

    // 任务详细信息
    showDetailPage() {
      const data = this.$refs.gridForTaskList.rowData;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }

      this.$axios.get(`/lte/pm/measuretaskmanagement/getNeInfoByTaskId.html?taskId=${data.sysMeterTaskId}`).then((response) => {
        console.log(response);
        this.neTypeId = response.data.resultVal[0].neTypeCode;
      });

      this.paramsOfDetail = {
        sysMeterTaskName: data.sysMeterTaskName,
        meterTimePeriod: data.meterTimePeriod / 60000 < 60 ? `${data.meterTimePeriod / 60000}${this.$t('Alarm.minute')}` : `${data.meterTimePeriod / 60000}${this.$t('Alarm.hour')}`,
        effectiveTimeMode: data.effectiveTimeMode == '1' ? this.$t('Pm.longTime') : this.$t('Pm.periodTime'),
        meterBegTime: data.meterBegTime,
        meterEndTime: data.meterEndTime,
        sysMeterTaskDepict: data.sysMeterTaskDepict
      };
      this.$axios.get(`/lte/pm/measuretaskmanagement/getTaskDetailInfo.html?sysMeterTaskId=${data.sysMeterTaskId}`).then((response) => {
        const result = response.data.resultVal;
        const dataList = [];
        for (let i = 0; i < result.length; i++) {
          if (result[i].pid == '') {
            dataList.push({
              id: result[i].id,
              neName: result[i].neName,
              measureTypeName: result[i].measureTypeName,
              measureObjectName: result[i].measureObjectName,
              meterStatus: result[i].meterStatus,
              parentItem: null,
              isParent: true
            });
          } else {
            dataList.push({
              id: result[i].id,
              neName: result[i].neName,
              measureTypeName: result[i].measureTypeName,
              measureObjectName: result[i].measureObjectName,
              parentItem: result[i].pid,
              meterStatus: result[i].meterStatus,
              isParent: false
            });
          }
        }
        this.$refs.showDetail.dataOfDetail = dataList;
      });
      this.$refs.showDetailPage.show();
    },

    // 关闭添加或修改非实时任务第一步弹出框
    closeAddOrModifyTaskPage1() {
      this.$refs.addOrModifyTaskPage1.close();
    },

    // 关闭添加或修改非实时任务第二步弹出框
    closeAddOrModifyTaskPage2() {
      this.$refs.addOrModifyTaskPage2.close();
    },

    // 关闭非实时任务详细信息弹出框
    closeShowDetailPage() {
      this.$refs.showDetailPage.close();
    },

    // 下一步
    nextForTask() {
      const ruleDatas = this.$refs.AddOrModifyTaskDialog1.validateOfDialog1();
      if (!ruleDatas) {
        return;
      }
      this.paramsOfFirstStep = this.$refs.AddOrModifyTaskDialog1.paramsOfDialog1;
      if (this.paramsOfFirstStep.meterBegTime.getTime() > this.paramsOfFirstStep.meterEndTime.getTime()) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.startNoLagerThanEnd') });
        return;
      }

      if (this.paramsOfFirstStep.meterEndTime.getTime() < new Date().getTime()) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.endNoEarilerThanCurrent') });
        return;
      }
      this.$refs.AddOrModifyTaskDialog2.$refs.NeTreeForCreate.getNeIdsUnderTask();
      this.$refs.AddOrModifyTaskDialog2.$refs.NeTreeForCreate.getNeTree(this.paramsOfFirstStep.neType, this.taskId);
      this.$refs.addOrModifyTaskPage1.close();
      this.$refs.addOrModifyTaskPage2.show();
    },

    // 上一步
    preForTask() {
      if (this.addOrModifyTaskFlag == '2') {
        this.$refs.AddOrModifyTaskDialog1.status = {
          begTimeEnabled: false,
          endTimeEnabled: false,
          neTypeEnabled: false,
          timeCycleEnabled: false,
          timeModeEnabled: false,
          readForTaskName: true,
        };
      }
      this.$refs.AddOrModifyTaskDialog1.bindValidateOfDialog1();
      this.$refs.AddOrModifyTaskDialog1.paramsOfDialog1 = this.paramsOfFirstStep;
      this.$refs.addOrModifyTaskPage2.close();
      this.$refs.addOrModifyTaskPage1.show();
    },

    // 完成
    async completeAddOrModifyTask() {
      const treeGridLists = this.$refs.AddOrModifyTaskDialog2.treeGridList;
      if (treeGridLists.length == 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectMOplease') });
        return;
      }
      await this.$axios.get(`/lte/pm/measuretaskmanagement/hasSameNameTask.html?taskName=${this.paramsOfFirstStep.sysMeterTaskName}&systemId=1`)
        .then((response) => {
          this.hasSame = response.data.resultVal;
        });

      if (this.hasSame && (this.addOrModifyTaskFlag == '1')) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.hasSameTaskName') });
        return;
      }

      this.neWithMeasureObjs = [];
      for (let i = 0; i < treeGridLists.length; i++) {
        if (treeGridLists[i].parentItem == null) {
          const neid = treeGridLists[i].id;
          const ConfigMeasureObjectTypeSubs = [];
          for (let j = 0; j < treeGridLists.length; j++) {
            if (treeGridLists[j].parentItem == neid) {
              ConfigMeasureObjectTypeSubs.push(treeGridLists[j].configMeasureObjectTypeSub);
            }
          }
          this.neWithMeasureObjs.push({
            neId: neid,
            configMeasureObjectTypeSubs: ConfigMeasureObjectTypeSubs,
          });
          this.neIdsForTask.push(neid);
        }
      }
      if (this.addOrModifyTaskFlag == '1') {
        this.sendCmdAndRecieveData('/lte/pm/measuretaskmanagement/addConfigSysMeterTask.html',
          {
            effectiveTimeMode: this.paramsOfFirstStep.effectiveTimeMode,
            meterBegTime: dateUtil.getDateString(this.paramsOfFirstStep.meterBegTime),
            meterEndTime: dateUtil.getDateString(this.paramsOfFirstStep.meterEndTime),
            meterTimePeriod: this.paramsOfFirstStep.meterTimePeriod,
            neWithMeasureObjs: this.neWithMeasureObjs,
            sysMeterTaskDepict: this.paramsOfFirstStep.sysMeterTaskDepict,
            sysMeterTaskName: this.paramsOfFirstStep.sysMeterTaskName,
            systemId: '1',
            webSocketId: new Date().getTime(),
            userName: JSON.parse(sessionStorage.getItem('principal')).username
          }, 2);
      } else {
        for (let i = 0; i < this.neIdsUnderTaskByTaskId.length; i++) {
          const neId = this.neIdsUnderTaskByTaskId[i];
          if (!this.neIdsForTask.includes(neId)) {
            this.delNeIdsOfModify.push(neId);
          }
        }
        this.sendCmdAndRecieveData('/lte/pm/measuretaskmanagement/doEditTask.html',
          {
            effectiveTimeMode: this.paramsOfFirstStep.effectiveTimeMode,
            meterBegTime: dateUtil.getDateString(this.paramsOfFirstStep.meterBegTime),
            meterEndTime: dateUtil.getDateString(this.paramsOfFirstStep.meterEndTime),
            meterTimePeriod: this.paramsOfFirstStep.meterTimePeriod,
            neWithMeasureObjs: this.neWithMeasureObjs,
            sysMeterTaskDepict: this.paramsOfFirstStep.sysMeterTaskDepict,
            sysMeterTaskName: this.paramsOfFirstStep.sysMeterTaskName,
            systemId: '1',
            taskId: this.taskId,
            sysMeterTaskId: this.taskId,
            userName: JSON.parse(sessionStorage.getItem('principal')).username,
            neTypeId: this.neTypeId,
            delNeIds: this.delNeIdsOfModify
          }, 3);
      }

      this.$refs.addOrModifyTaskPage2.close();
    },
    taskStatusChange(msg) {
      this.taskStatus = msg;
    },

    // 控制台对话框的单击确认按钮事件
    confirmCmdConsolePage() {
      if (!this.cmdExeFinshFlag) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.waitCommandFinish') });
        return;
      }
      this.$refs.cmdConsolePage.close();
      this.$refs.gridForTaskList.initTaskList({ treeType: '1' });
      this.$emit('refresh');
    },

    // 发送命令并接收命令响应
    sendCmdAndRecieveData(url, item, httpMethod) {
      const _this = this;
      this.$refs.cmdConsolePage.show();
      this.cmdExeFinshFlag = false;

      // 变更确定按钮样式
      this.$refs.CmdConsole.buttonColorCss(false);

      // 建立websock同时订阅主题
      // httpMethod = 1 时为其他任务操作
      if (httpMethod == 1 || httpMethod == 3) {
        if (!pmSocket.socket || pmSocket.socket.readyState == 2 || pmSocket.socket.readyState == 3) {
          this.payload[0].clientId = item.sysMeterTaskId;
          pmSocket.init(this.payload);
        } else {
          if (pmSocket.subscribes[pmSocket.__buildSubscribeTopic(item.sysMeterTaskId, this.payload[0].topic)]) {
            // 主题已经存在无需特别处理
          } else {
            pmSocket.dynamicSubscribe(this.payload[0].topic, item.sysMeterTaskId, this.payload[0].callback);
          }
        }
      } else { // httpMethod = 2 时为创建任务操作，无taskId传入
        if (!pmSocket.socket || pmSocket.socket.readyState == 2 || pmSocket.socket.readyState == 3) {
          this.payload[0].clientId = item.webSocketId;
          pmSocket.init(this.payload);
        } else {
          if (pmSocket.subscribes[pmSocket.__buildSubscribeTopic(item.webSocketId, this.payload[0].topic)]) {
            // 主题已经存在无需特别处理
          } else {
            pmSocket.dynamicSubscribe(this.payload[0].topic, item.webSocketId, this.payload[0].callback);
          }
        }
      }
      this.timer1 = window.setInterval(function () {
        _this.$refs.CmdConsole.appendConsoleMsg(_this.$t('Pm.taskInProgress'));
      }, 2000);

      if (httpMethod == 1) {
        this.delaySendCmd(url, { 'taskId': item.sysMeterTaskId }, httpMethod);
      } else {
        this.delaySendCmd(url, item, httpMethod);
      }
    },

    /**
     * type CONNECTING = 0;
     * type OPEN = 1;
     * type CLOSING = 2;
     * type CLOSED = 3;
     */
    delaySendCmd(url, params, httpMethod) {
      const _this = this;
      this.timer2 = window.setInterval(function () {
        if (pmSocket.socket.readyState == 1) {
          clearInterval(_this.timer2);
          _this.sendParams(url, params, httpMethod);
        }
      }, 5000);
    },

    sendParams: async function (url, params, httpMethod) {
      const _this = this;
      if (httpMethod == 1) {
        await this.$axios.get(url + commonUtil.analyticParameter(params), {}).then(response => {
          _this.$refs.CmdConsole.appendConsoleMsg(response.data.errorString);
          // 变更确定按钮样式
          this.$refs.CmdConsole.buttonColorCss(true);
          this.cmdExeFinshFlag = true;
          clearInterval(_this.timer1);
          this.$refs.gridForTaskList.initTaskList(this.queryParams);
        });
      } else {
        await this.$axios.post(url, params).then(response => {
          _this.$refs.CmdConsole.appendConsoleMsg(response.data.errorString);
          // 变更确定按钮样式
          _this.$refs.CmdConsole.buttonColorCss(true);
          this.cmdExeFinshFlag = true;
          clearInterval(_this.timer1);
          this.$refs.gridForTaskList.initTaskList(this.queryParams);
        });
      }
    },

    /**
     * websocket回调函数
     */
    pmWebsocketLisenerOfNoReal(response) {
      // websocek响应转换成JavaScript对象
      const msg = JSON.parse(response.body);
      // 控制台打印结果
      this.buildRecvOperationInfo(msg);
    },

    /**
     * 组建接收的操作信息
     */
    buildRecvOperationInfo(response) {
      // 目前上报的信息是一个网元的完整操作信息，而不是产生一条上报一条
      for (let i = 0; i < response.messages.length; i++) {
        this.$refs.CmdConsole.appendConsoleMsg(`${response.messages[i].message}【${dateUtil.getDateString(new Date(response.messages[i].time))}】`);
      }
      this.$refs.CmdConsole.appendConsoleMsg('---------------------------------------');
    },
  },
  watch: {
    queryParams(queryParams) {
      this.$refs.gridForTaskList.initTaskList(queryParams);
    },
  }
};
</script>

<style>
</style>
